import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, Suspense, createElement } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

function LoadingFallback() {
  return createElement('div', {
    className: 'flex items-center justify-center h-64'
  }, createElement('div', {
    className: 'flex flex-col items-center gap-3'
  }, createElement('i', {
    className: 'ri-loader-4-line animate-spin text-3xl text-teal-500'
  }), createElement('span', {
    className: 'text-sm text-gray-500'
  }, '加载中...')));
}

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return createElement(Suspense, { fallback: createElement(LoadingFallback) }, element);
}
